<template>
    <div id="CycleBadgeIntro" class="w3 w90-mb">
        <h1 class="h1">循環產品標章</h1>
        <section id="cycle-badge-intro-meaning">
            <img
                :src="require('@/assets/png/badge/badge.png')"
                alt="循環產品標章"
            />
            <article>
                <h2 class="h2">標章圖樣與意涵</h2>
                <p class="p1">
                    循環產品標章以波浪代表象徵海洋，廢寶特瓶既是廢棄物，亦可回收後再生製成產品。圓弧形波浪將寶特瓶托起形成永續循環，作為海洋廢棄物循環產品標章的意涵。
                </p>
            </article>
        </section>
        <section id="cycle-badge-intro-process">
            <h2 class="h2">標章申請流程</h2>
            <div class="button-group">
                <button
                    class="small-btn"
                    :class="{ activated: activatedProcessId === 0 }"
                    @click="activatedProcessId = 0"
                    @keypress.enter="activatedProcessId = 0"
                >
                    首次申請
                </button>
                <button
                    class="small-btn"
                    :class="{ activated: activatedProcessId === 1 }"
                    @click="activatedProcessId = 1"
                    @keypress.enter="activatedProcessId = 1"
                >
                    期滿展延
                </button>
            </div>
            <figure v-show="activatedProcessId === 0">
                <img
                    v-if="isMobile"
                    :src="
                        require('@/assets/png/badge/first-application-mb.png')
                    "
                    alt="首次申請流程圖"
                />
                <img
                    v-else
                    :src="require('@/assets/png/badge/first-application.png')"
                    alt="首次申請流程圖"
                />

                <figcaption class="hide hide-mb">
                    1.於申請人之準備期，申請人可向驗證機構申請查證，驗證機構受理後會進行查證，並向申請人出具查證報告。申請人取得查證聲明與報告後，即可開始準備申請標章。
                    2.申請標章須檢附申請表、查證聲明及報告、標爭標示方式說明，以此三份文件向環保署提出申請後。環保署受理申請後將參考作業要點第4點及第5點進行形式審查，審查期間若有需要會請申請人進行資料補正，詳細內容可參考作業要點第6點，申請通過後將同意申請人使用標章。
                </figcaption>
            </figure>
            <figure v-show="activatedProcessId === 1">
                <img
                    v-if="isMobile"
                    :src="
                        require('@/assets/png/badge/expiration-extension-mb.png')
                    "
                    alt="期滿展延流程圖"
                />
                <img
                    v-else
                    :src="
                        require('@/assets/png/badge/expiration-extension.png')
                    "
                    alt="期滿展延流程圖"
                />
                <figcaption class="hide hide-mb">
                    1.於期滿展延期間，申請人可向驗證機構申請重新查證，驗證機構受理後會進行查證，並向申請人出具查證報告。申請人取得查證聲明與報告後，即可開始準備申請標章。
                    2.申請標章須檢附申請表、查證聲明及報告、標爭標示方式說明，以此三份文件向環保署提出申請後。環保署受理申請後將參考作業要點第4點及第5點進行形式審查，審查期間若有需要會請申請人進行資料補正，詳細內容可參考作業要點第6點，申請通過後將同意申請人使用標章。
                </figcaption>
            </figure>
        </section>
        <section id="cycle-badge-intro-organization">
            <h2 class="h2">驗證機構</h2>
            <p class="p1">
                國內或國際專業且公正客觀之驗證機構，同時符合 ISO 17065 及 ISO
                17021，足以查驗海洋廢棄物來源、生產等管理機制運作者。
            </p>
            <div class="organization-group" id="organization-group1">
                <h3 class="h3">驗證機構查詢</h3>
                <ul>
                    <li>
                        <img
                            :src="require('@/assets/png/badge/IAF.png')"
                            alt="IAF LOGO"
                        />
                        <article>
                            <p class="p1 title">
                                國際認證論壇 International Accreditation Forum
                            </p>
                            <a
                                href="https://iaf.nu/en/accreditation-bodies/"
                                target="_blank"
                                class="link"
                                ><span>國際認證機構查詢</span></a
                            >
                        </article>
                    </li>
                    <li>
                        <img
                            :src="require('@/assets/png/badge/TAF.png')"
                            alt="TAF LOGO"
                        />
                        <article>
                            <p class="p1 title">
                                財團法人全國認證基金會 Taiwan Accreditation
                                Foundation
                            </p>
                            <a
                                href="https://www.taftw.org.tw/directory/scheme/msv/"
                                target="_blank"
                                class="link"
                                ><span
                                    >ISO/IEC 17021-1 管理系統驗證機構查詢</span
                                ></a
                            >
                            <br />
                            <a
                                href="https://www.taftw.org.tw/directory/scheme/pva/"
                                target="_blank"
                                class="link"
                                ><span>ISO/IEC 17065 產品驗證機構查詢</span></a
                            >
                        </article>
                    </li>
                </ul>
            </div>
            <!-- <div class="organization-group" id="organization-group2">
                <h3 class="h3">各國驗證機構</h3>
                <ul>
                    <li v-for="item in organizationList" :key="item.title">
                        <div class="img-wrap">
                            <img
                                :src="item.imgUrl"
                                :alt="item.title + ' LOGO'"
                            />
                        </div>
                        <p class="p1 title">{{ item.title }}</p>
                    </li>
                </ul>
            </div> -->
        </section>
        <section id="cycle-badge-intro-download">
            <h2 class="h2">相關檔案下載</h2>
            <ul class="download-group">
                <li>
                    <p class="p1 title">
                        海洋廢棄物循環產品標章推動作業要點<br />
                        Operation Directions for Recycled Marine Debris Product
                        Label
                    </p>
                    <a
                        href="../pdf/OperationCh.pdf"
                        target="_blank"
                        class="link"
                    >
                        <i class="icon-clip"></i><span>中文版</span>
                    </a>
                    <a
                        href="../pdf/OperationEn.pdf"
                        target="_blank"
                        class="link"
                    >
                        <i class="icon-clip"></i><span>English Version</span>
                    </a>
                </li>
                <li>
                    <p class="p1 title">
                        海洋廢棄物循環產品標章使用規範書（含申請書）<br />
                        Specifications Governing Use of Recycled Marine Debris
                        Product Label
                    </p>

                    <a
                        href="../pdf/SpecificationsCh.pdf"
                        target="_blank"
                        class="link"
                    >
                        <i class="icon-clip"></i><span>中文版</span>
                    </a>
                    <a
                        href="../pdf/SpecificationsEn.pdf"
                        target="_blank"
                        class="link"
                    >
                        <i class="icon-clip"></i><span>English Version</span>
                    </a>
                </li>
            </ul>
        </section>
    </div>
</template>
<script>
import { computed, ref } from 'vue'
export default {
    name: 'CycleBadgeIntro',
    setup() {
        const isMobile = computed(() => window.innerWidth < 768)
        const activatedProcessId = ref(0)
        const organizationList = [
            {
                title: '泰國 NSC',
                imgUrl: require('@/assets/png/badge/NSC.png'),
            },
            {
                title: '中國 CNAS',
                imgUrl: require('@/assets/png/badge/CNAS.png'),
            },
            {
                title: '英國 UKAS',
                imgUrl: require('@/assets/png/badge/UKAS.png'),
            },
            {
                title: '越南 BoA',
                imgUrl: require('@/assets/png/badge/BOA.png'),
            },
            {
                title: '南韓 KAB',
                imgUrl: require('@/assets/png/badge/KAB.png'),
            },
        ]
        return { activatedProcessId, organizationList, isMobile }
    },
}
</script>
<style lang="scss" scoped>
#CycleBadgeIntro {
    padding-bottom: 50px;
}
p.title {
    margin: 5px 0;
    text-indent: 0;
    line-height: 1.2em;
}
section {
    margin: 50px 0;
}
#cycle-badge-intro-meaning {
    img {
        display: block;
        width: 300px;
    }
    article {
        flex: 1;
    }
    @media screen and (min-width: 768px) {
        display: flex;
    }
    @media screen and (max-width: 767px) {
        img {
            margin: 0 auto 30px;
        }
    }
}
#cycle-badge-intro-process {
    button {
        display: inline-block;
        margin-top: 0;
        border: none;
        border-radius: 5px;
        background-color: $theme4;
        opacity: 0.4;

        &.activated {
            opacity: 1;
        }
    }
    img {
        display: block;
        width: 100%;
    }
    @media screen and (min-width: 768px) {
        .button-group {
            text-align: right;
        }
        button {
            margin-left: 10px;
        }
        figure {
            margin: 20px 0;
        }
    }
    @media screen and (max-width: 767px) {
        button {
            margin-right: 10px;
        }
        figure {
            margin: 20px -6%;
        }
    }
}
#cycle-badge-intro-organization {
    .organization-group {
        margin: 30px 0;
    }
    #organization-group1 {
        @media screen and (min-width: 768px) {
            li {
                display: flex;
                align-items: center;
            }
            img {
                width: 150px;
            }
            article {
                flex: 1;
                margin-left: 30px;
            }
        }
        @media screen and (max-width: 767px) {
            li {
                position: relative;
                margin-bottom: 30px;
            }
            img {
                position: absolute;
                top: -15px;
                right: 0;
                width: 80px;
            }
            p {
                text-align: left;
                padding-right: 90px;
            }
        }
    }
    #organization-group2 {
        ul {
            display: flex;
            flex-wrap: wrap;
        }
        .title {
            text-align: center;
        }
        .img-wrap {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        @media screen and (min-width: 768px) {
            li {
                width: 150px;
            }
            .img-wrap {
                height: 105px;
            }
            img {
                max-width: 100px;
                max-height: 100px;
            }
        }
        @media screen and (max-width: 767px) {
            li {
                width: 100px;
            }
            .img-wrap {
                height: 70px;
            }
            img {
                max-width: 60px;
                max-height: 60px;
            }
        }
    }
}
#cycle-badge-intro-download {
    .download-group {
        li {
            position: relative;
            padding-left: 1.2em;
            margin-bottom: 30px;
            &:before {
                content: '・';
                position: absolute;
                left: 0;
                top: 0;
                line-height: 1.2em;
            }
        }
    }
    @media screen and (max-width: 767px) {
        p {
            text-align: left;
            padding-right: 10px;
        }
    }
}
</style>
